import { Box, Paper, Typography } from "@mui/material";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderTitle } from "./HeaderTitle";
import { NavigationControls } from "./NavigationControls";
import { ViewToggle } from "./ViewToggle";
import { CALENDAR_VIEWS, flownectColors } from "../../const";
import { colors } from "../../../../ui/colors";
import dayjs from "dayjs";

export const CalendarHeader = ({ currentWeek, viewType, onPrev, onNext, onToday, onViewChange, events }) => {
  const count = (() => {
    if (!events || !Array.isArray(events) || events.length === 0) return 0;

    return events.filter((event) => {
      const eventDate = dayjs(event.start);
      if (!eventDate.isValid()) return false;

      switch (viewType) {
        case "timeGridDay":
        case CALENDAR_VIEWS.DAY:
          return eventDate.isSame(currentWeek, "day");
        case "dayGridMonth":
        case CALENDAR_VIEWS.MONTH:
          return eventDate.isSame(currentWeek, "month");
        case "listWeek":
        case CALENDAR_VIEWS.LIST:
          return eventDate.isAfter(currentWeek.startOf("week").subtract(1, "ms")) && eventDate.isBefore(currentWeek.endOf("week").add(1, "ms"));
        default:
          return false;
      }
    }).length;
  })();

  const getCountText = () => {
    if (count === 0) return "No jobs scheduled";

    const jobs = count === 1 ? "job" : "jobs";

    switch (viewType) {
      case CALENDAR_VIEWS.DAY:
        return `${count} ${jobs} scheduled for today`;
      case CALENDAR_VIEWS.MONTH:
        return `${count} ${jobs} scheduled for this month`;
      case CALENDAR_VIEWS.LIST:
        return `${count} ${jobs} scheduled for this week`;
      default:
        return `${count} ${jobs} scheduled`;
    }
  };

  return (
    <Paper elevation={0} sx={{ px: 3, bgcolor: "var(--fx-surface-base, #FFFFFF)" }}>
      <Box display={"flex"} paddingY={3} alignItems={"center"} justifyContent={"space-between"} mb={1}>
        <Typography
          variant="h5"
          sx={{
            fontSize: 30,
            fontWeight: 900,
          }}
        >
          Job Calendar
        </Typography>

        <ViewToggle viewType={viewType} onViewChange={onViewChange} />
      </Box>

      <HeaderTitle onNext={onNext} onPrev={onPrev} currentWeek={currentWeek} viewType={viewType} />

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", paddingRight: 2, paddingLeft: 2 }}>
        <Typography
          sx={{
            display: viewType === CALENDAR_VIEWS.DAY ? "none" : "block",
            color: colors.orange.base,
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "1.5px",
            fontSize: "0.65rem",
          }}
        >
          {getCountText()}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%" }}>
          <NavigationControls viewType={viewType} onToday={onToday} />
        </Box>
      </Box>
    </Paper>
  );
};
